import { render, staticRenderFns } from "./customAssetInfo.vue?vue&type=template&id=09d0ee8b&scoped=true&"
import script from "./customAssetInfo.vue?vue&type=script&lang=js&"
export * from "./customAssetInfo.vue?vue&type=script&lang=js&"
import style0 from "./customAssetInfo.vue?vue&type=style&index=0&id=09d0ee8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d0ee8b",
  null
  
)

export default component.exports